import { oz } from '@weft/utils';
import { ClientChannelSchema } from './client-channel-schema';
import { EmailChannelSchema } from './email-channel-schema';
import { SlackChannelSchema } from './slack-channel-schema';
import { WebhookChannelSchema } from './webhook-channel-schema';

export const NotificationChannelSchema = oz.discriminatedUnion('type', [
  ClientChannelSchema,
  EmailChannelSchema,
  SlackChannelSchema,
  WebhookChannelSchema,
]).openapi('NotificationChannel');

export type NotificationChannel = oz.infer<typeof NotificationChannelSchema>;